<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                
                <v-row justify="end" align="end" class="mx-3 mt-3" v-if="show_rfid">
                    <v-btn class="right " color="secondary" outlined @click="show_rfid = false;">
                        {{ $t('locations_details.go_back') }}
                    </v-btn>
                </v-row>

                <rfid-settings v-if="show_rfid" ref="showSettings" :tag_per_product="rfid_by_product" :product_id="id" :items="rfid_items" ></rfid-settings>
                <v-row class="px-5 pt-5" justify="center" align="center" v-if="!show_rfid">
                    <v-col cols="5" align="start" justify="start">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('product_details.details') }}</h3>
                    </v-col>
                    <v-col cols="3" align="end" justify="end">
                        <v-row justify="end" aling="end" class="mx-0 px-0">
                            <v-btn class="right mr-3" color="secondary" outlined @click="print_tags">
                                RFID
                            </v-btn>
                            
                            <v-btn class="right white_highlight--text" color="secondary" @click="cancel" >
                                {{ $t('product_details.go_back') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
                <v-card-text class="px-0" v-if="!show_rfid">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" >
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.sku')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.sku }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" >
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.barcode')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.barcode }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" >
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.description')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.description }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" >
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.client')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.client.name }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.category')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.category.name }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.refill_alert')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.storage_policy }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.unit')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.unit }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.size_unit')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.size_unit }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.height')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.height }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.length')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.length }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.width')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.width }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" v-if="!client_hd">
                            <v-col cols="8" class="py-0 px-6">
                                <v-row class="px-0 py-2 my-0" justify="center" align="center" style="border-bottom:1px solid black;">
                                    <label>{{ $t('product_details.weight')}}</label>
                                    <v-spacer></v-spacer>
                                    <label> {{ this.product.weight }} </label>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center" >
                            <v-col cols="8" class="py-0 px-3">
                                <datatable v-if="client_hd" :props="{ headers: headers_hd, items: product.detailed_stock }" @methodHandler="methodHandler"></datatable>
                                <datatable v-else :props="{ headers: headers, items: product.detailed_stock }" @methodHandler="methodHandler"></datatable>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>    
        </v-container>   
        <v-dialog v-model="modalEdit" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center" class="mt-4">
                        <h3 class="text-uppercase">
                            {{ $t('product_details.create_damaged') }}
                        </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                       <v-row class="px-5 py-0 mt-7 mb-0" justify="center" align="center">
                            <v-col cols="9" class="py-0">
                                <v-text-field class="py-0" v-model="detail_to_update.sku" disabled :label="$t('edit_detailed_stock.sku')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 mt-1 mb-0" justify="center" align="center">
                            <v-col cols="9" class="py-0">
                                <v-text-field class="py-0" v-model="detail_to_update.quantity" disabled :label="$t('edit_detailed_stock.quantity')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 mt-1 mb-0" justify="center" align="center">
                            <v-col cols="9" class="py-0">
                                <v-text-field class="py-0" type="number" v-model="detail_to_update.damaged" :label="$t('edit_detailed_stock.damaged')" :rules="numeric_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 mt-1 mb-0" justify="center" align="center">
                            <v-col cols="9" class="py-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="detail_to_update.quarantine" :label="$t('product_details.quarantine')"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-form>
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn class="mx-3" text @click="modalEdit = false">{{ $t('product_details.cancel') }}</v-btn>
                        <v-btn color="warning" class="white_highlight--text" @click="updateDetail">
                            {{ $t('product_details.save') }}
                        </v-btn>
                    </div>
                </v-card-text> 
                <div class="marker2"></div>
            </v-card>
        </v-dialog>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { showProductUseCase } from "../application/use_cases/show_product_use_case";
import { HttpProductRepository } from "../infrastructure/product_repository";
import { updateProductDetailedStockUseCase } from "../../shared/application/use_cases/update_product_detailed_stock_use_case";
import { HttpDetailedStockRepository } from "../../shared/infrastructure/repositories/detailed_stock_repository";

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        numeric_required(){
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => v <= this.detail_to_update.quantity || this.$t('product_details.quantity_higher') + '(' + this.detail_to_update.quantity + ')',
            ];
        }
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            locations: [],
            client_hd: false,
            product: {
                sku: "",
                description: "",
                unit: "",
                barcode: '', 
                height: '', 
                length : '', 
                width: '',
                size_unit: '',
                category:{
                    name: "",
                },
                storage_policy: "",
                weight: "",
                client: {
                    name: ""
                }
            },
            is_rfid: false,
            show_rfid: false,
            rfid_items: {
                pallets:[],
                boxes: [],
                tags: []
            },
            modalEdit: false,
            detail_to_update: {  
                id: '',
                quarantine: false,
                quantity: '',
                sku: '',
                damaged: 0,
            },
            rfid_by_product: false,
            headers: [
                { text: this.$t('product_details.location'), align: "center", value: 'location.name', class: 'text-uppercase' },
                { text: this.$t('product_details.pallet'), align: "center", value: 'pallet_per_location.pallet', class: 'text-uppercase' },
                { text: this.$t('product_details.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('product_details.reserved'), align: "center", value: 'reserved', class: 'text-uppercase' },
                { text: this.$t('product_details.batch'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('product_details.expiration'), align: "center", value: 'reference', class: 'text-uppercase' },
                { text: this.$t('product_details.date'), align: "center", value: 'created_at', class: 'text-uppercase' },
                { text: "", align: "center", value: 'actions', class: 'text-uppercase' }
            ],
            headers_hd: [
                { text: this.$t('product_details.location'), align: "center", value: 'location.name', class: 'text-uppercase' },
                { text: this.$t('product_details.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('product_details.reserved'), align: "center", value: 'reserved', class: 'text-uppercase' },
                { text: this.$t('product_details.part_number'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('product_details.weight'), align: "center", value: 'reference', class: 'text-uppercase' },
                { text: this.$t('product_details.container'), align: "center", value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('product_details.date'), align: "center", value: 'created_at', class: 'text-uppercase' },
                { text: "", align: "center", value: 'actions', class: 'text-uppercase' }
            ]
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.product_details";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                const result = await showProductUseCase(this.id, HttpProductRepository);

                this.product = result;

                this.client_hd = this.product.client.client_type == 'DEFAULT' ? false : true;
                this.rfid_by_product = this.product.client.rfid_by_product;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        save(){
        },
        print_tags(id){
            console.log(id);
            this.$store.state.loaderProps.visible = true;

            var t = this
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'rfid/product/' + this.id, {headers: {Authorization: lsToken}})
            .then(response => {
                t.rfid_items = response.data.items
                t.show_rfid = true
                
            })
            .catch(err => {console.log(err)})
            .finally(()=>{this.$store.state.loaderProps.visible = false;})
        },
        showModalEdit(detail_id){
            this.id_detail_to_update = detail_id;
            const detail = this.product.detailed_stock.find(x => x.id == detail_id);

            this.detail_to_update = {  
                id: detail_id,
                quarantine: false,
                quantity: detail.quantity,
                sku: this.product.sku,
                damaged: "",
            }

            this.modalEdit = true;
        },
        async updateDetail(){
            try{
                this.detail_to_update.damaged = parseInt(this.detail_to_update.damaged);
            
                const response = await updateProductDetailedStockUseCase(this.detail_to_update, HttpDetailedStockRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: response.data.success.message
                }

                await this.index();

                this.detail_to_update = {  
                    id: '',
                    quarantine: false,
                    quantity: '',
                    sku: '',
                    damaged: 0,
                }

                this.modalEdit = true;
                // this.$router.go(-1);                  
            } catch (e) {
                console.log(e.response);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        }
    },
    watch:{}
}
</script>

<style lang="css">
</style>